import React, {useContext, useEffect, useState} from "react";
import {
    Button,
    Col,
    ConfigProvider,
    DatePicker,
    Form,
    Modal,
    Row,
    Select,
    Table,
    Tag,
    Spin,
    InputNumber,
} from "antd";
import locale from "antd/es/locale/ca_ES";
import {BiEnvelope, BiPlus, BiChevronRight} from "react-icons/bi";
import Colors from "../../../styles/Colors";
import {AuthContext} from "../../../config/AuthContext";
import dayjs from "dayjs";
import {GetProveidors} from "../../../dao/menudesign/GetProveidors";
import {GetIngredients} from "../../../dao/menudesign/GetIngredients";
import {PostComandaGeneradaNova} from "../../../dao/menudesign/comandes/PostComandaGeneradaNova";

interface NovaComandaModalProps {
    visible: boolean;
    onClose: (value: boolean) => void;
}

const NovaComandaModal: React.FC<NovaComandaModalProps> = ({visible, onClose}) => {
    const {page} = useContext(AuthContext);
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);
    const [tipusComanda, setTipusComanda] = useState<string>("0");
    const [proveidor, setProveidor] = useState<string | null>(null);
    const [dataInici, setDataInici] = useState<dayjs.Dayjs | null>(null);
    const [dataFinal, setDataFinal] = useState<dayjs.Dayjs | null>(null);
    const [dades, setDades] = useState<any[]>([]);
    const [proveidors, setProveidors] = useState<any[]>([]);
    const [nouIngredientVisible, setNouIngredientVisible] = useState(false);

    useEffect(() => {
        if (visible) {
            carregarProveidors();
        }
    }, [visible]);

    async function carregarProveidors() {
        setLoading(true);
        try {
            const res = await GetProveidors(page);
            setProveidors(res || []);
        } catch (e) {
            console.error("Error carregant proveïdors:", e);
        } finally {
            setLoading(false);
        }
    }

    async function buscarComandes() {
        setLoading(true);
        try {
            if (!isFormValid) return;

            const novaComanda: any = {
                id_proveidor: proveidor,
                inici: dataInici ? dataInici.format("YYYY-MM-DD") : null,
                fin: dataFinal ? dataFinal.format("YYYY-MM-DD") : null,
                tipus: Number(tipusComanda)
            };
            console.log(novaComanda);
            const res = await PostComandaGeneradaNova(page, novaComanda);
            setDades(res || []);
        } catch (e) {
            console.error("Error carregant comandes:", e);
        } finally {
            setLoading(false);
        }
    }

    const columns = [
        {key: "id", dataIndex: "id", title: "ID"},
        {key: "ingredient", dataIndex: "ingredient", title: "Ingredient"},
        {
            key: "quantitat",
            dataIndex: "quantitat",
            title: "Quantitat",
            render: (val: number, ele: any) => (
                <Tag color={Colors.colors.color4}>
                    {parseFloat(String(val)).toFixed(2)} {ele.mesura}
                </Tag>
            ),
        },
        {
            key: "dia",
            dataIndex: "dia",
            title: "Dia",
            render: (val: string) => <Tag>{dayjs(val).format("DD-MM-YYYY")}</Tag>,
        },
        {
            key: "afegit",
            dataIndex: "afegit",
            title: "Afegit",
            render: (val: number) => (
                <Tag color={val === 1 ? Colors.colors.color2 : Colors.colors.color5}>
                    {val === 1 ? "SÍ" : "NO"}
                </Tag>
            ),
        },
    ];

    const isFormValid = !!(
        tipusComanda &&
        proveidor &&
        dataInici &&
        dataFinal
    );

    return (
        <ConfigProvider locale={locale}>
            <Modal
                title="Nova Comanda"
                open={visible}
                onCancel={() => onClose(false)}
                width={1100}
                footer={null}
            >
                <Spin spinning={loading}>
                    <Form form={form} layout="vertical">
                        <Row gutter={[16, 16]} align="middle">
                            <Col span={6}>
                                <Form.Item label="Tipus de comanda">
                                    <Select
                                        value={tipusComanda}
                                        onChange={setTipusComanda}
                                        options={[
                                            {value: "0", label: "Segons dades de Proposta Comanda"},
                                            {value: "1", label: "Segons dades de Menú"},
                                        ]}
                                    />
                                </Form.Item>
                            </Col>

                            <Col span={6}>
                                <Form.Item label="Proveïdor">
                                    <Select
                                        placeholder="Selecciona..."
                                        value={proveidor ?? undefined}
                                        onChange={setProveidor}
                                        options={proveidors.map((p) => ({
                                            value: p.id,
                                            label: p.nom,
                                        }))}
                                    />
                                </Form.Item>
                            </Col>

                            <Col span={4}>
                                <Form.Item label="Del">
                                    <DatePicker
                                        value={dataInici}
                                        onChange={setDataInici}
                                        format="YYYY-MM-DD"
                                        style={{width: "100%"}}
                                    />
                                </Form.Item>
                            </Col>

                            <Col span={4}>
                                <Form.Item label="Fins al">
                                    <DatePicker
                                        value={dataFinal}
                                        onChange={setDataFinal}
                                        format="YYYY-MM-DD"
                                        style={{width: "100%"}}
                                    />
                                </Form.Item>
                            </Col>

                            <Col span={4} style={{display: "flex", gap: "6px"}}>
                                <Button
                                    type="primary"
                                    style={{backgroundColor: Colors.colors.color4}}
                                    icon={<BiChevronRight size={20}/>}
                                    onClick={buscarComandes}
                                    disabled={!isFormValid}
                                />

                                {tipusComanda === "1" && (
                                    <Button
                                        type="default"
                                        style={{backgroundColor: Colors.colors.color5}}
                                        icon={<BiPlus size={20}/>}
                                        onClick={() => setNouIngredientVisible(true)}
                                    />
                                )}

                                {/*<Button
                                    danger
                                    style={{backgroundColor: Colors.colors.color6}}
                                    icon={<BiEnvelope size={20}/>}
                                />*/}
                            </Col>

                        </Row>
                    </Form>

                    <Table
                        columns={columns}
                        dataSource={dades}
                        pagination={{pageSize: 20}}
                        style={{marginTop: 20}}
                        rowKey="id"
                    />
                </Spin>

                {/* 🔹 Modal interno de ingredientes */}
                <NouIngredientModal
                    visible={nouIngredientVisible}
                    onClose={(reload) => {
                        setNouIngredientVisible(false);
                        if (reload) buscarComandes();
                    }}
                />
            </Modal>
        </ConfigProvider>
    );
};

// 🔸 Submodal con unidad y step 0.5
const NouIngredientModal: React.FC<{
    visible: boolean;
    onClose: (reload?: boolean) => void;
}> = ({visible, onClose}) => {
    const [loading, setLoading] = useState(false);
    const [ingredients, setIngredients] = useState<any[]>([]);
    const [selected, setSelected] = useState<string | undefined>();
    const [mesura, setMesura] = useState<string | undefined>();
    const [quantitat, setQuantitat] = useState<number>(0);
    const {page} = useContext(AuthContext);

    useEffect(() => {
        if (visible) carregarIngredients();
    }, [visible, mesura]);

    async function carregarIngredients() {
        setLoading(true);
        try {
            const res = await GetIngredients(page);
            setIngredients(res || []);
        } catch (err) {
            console.error("Error carregant ingredients:", err);
        } finally {
            setLoading(false);
        }
    }

    function handleSelect(value: string) {
        setSelected(value);
        const found = ingredients.find((ing) => String(ing.id) === String(value));
        setMesura(found?.mesura || "");
    }


    function handleOk() {
        if (!selected || !quantitat) return;
        console.log("Ingredient seleccionat:", selected, "Quantitat:", quantitat, "Mesura:", mesura);
        onClose(true);
    }

    return (
        <Modal
            open={visible}
            onCancel={() => onClose(false)}
            onOk={handleOk}
            title="Afegir Ingredient"
            okText="Afegir"
            cancelText="Cancel·lar"
            width={500}
        >
            <Spin spinning={loading}>
                <Form layout="vertical">
                    <Form.Item label="Selecciona un ingredient">
                        <Select
                            showSearch
                            placeholder="Escriu per filtrar ingredients..."
                            optionFilterProp="label"
                            value={selected}
                            onChange={handleSelect}
                            options={ingredients.map((ing) => ({
                                value: ing.id,
                                label: ing.nom,
                            }))}
                            style={{width: "100%"}}
                        />
                    </Form.Item>

                    <Form.Item label="Quantitat">
                        <InputNumber
                            min={0}
                            step={0.5}
                            style={{width: "100%"}}
                            value={quantitat}
                            onChange={(v) => setQuantitat(Number(v))}
                            addonAfter={mesura ?? ""}
                        />
                    </Form.Item>
                </Form>
            </Spin>
        </Modal>
    );
};

export default NovaComandaModal;
